<template>
  <div class="container">
    <div
      v-if="loading"
      class="loading">
      <v-progress-circular indeterminate />
      Loading Graphics Config...
    </div>
    <div v-else>
      <div
        v-if="configOpen"
        class="config-open">
        <v-alert
          title="Ventuz Config is Open"
          type="error"
          variant="outlined">
          Please Ventuz Config and click Refresh
          <div class="refresh-btn">
            <v-btn
              @click="setGPU"
              :loading="refreshLoading">
              Refresh
            </v-btn>
          </div>
        </v-alert>
      </div>
      <div v-else>
        <v-select
          v-model="selectedGPU"
          label="GPU"
          :items="GPUS"
          item-title="name"
          item-value="template.index"></v-select>

        <v-select
          v-if="selectedGPU !== null"
          v-model="selectedOutput"
          @update:modelValue="handleOutputSelected"
          label="Output"
          :items="GPUS[selectedGPU].template.streams"
          item-title="name"
          item-value="template.jacks"></v-select>
      </div>
    </div>
  </div>
</template>
<script setup>
import { getGPUInfo } from '../../utils/ventuzConfig';
import { onMounted, ref } from 'vue';

const props = defineProps(['currentConfigName']);
const emit = defineEmits(['setGPUS', 'selectedGPUAndOutput']);

const selectedGPU = ref(null);
const selectedOutput = ref(null);

const GPUS = ref([]);
const configOpen = ref(null);

const loading = ref(true);
const refreshLoading = ref(false);

onMounted(async () => {
  await setGPU();
  loading.value = false;
});

async function setGPU() {
  refreshLoading.value = true;
  const data = await getGPUInfo();

  if (Array.isArray(data)) {
    configOpen.value = false;
    GPUS.value = data;
    emit('setGPUS', GPUS.value);
  } else {
    configOpen.value = true;
  }
  refreshLoading.value = false;
}

function handleOutputSelected() {
  emit('selectedGPUAndOutput', {
    gpu_index: selectedGPU.value,
    jack_port: selectedOutput.value,
  });
}
</script>
<style scoped>
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  margin: 2rem;
  margin-bottom: 4rem;
}
.container {
  width: 100%;
}

.config-open {
  margin: 2rem;
}

.refresh-btn {
  margin-top: 1rem;
}
</style>
